import { render } from "./ArchivoPlaDatos.vue?vue&type=template&id=1a0dc598&scoped=true"
import script from "./ArchivoPlaDatos.vue?vue&type=script&lang=js"
export * from "./ArchivoPlaDatos.vue?vue&type=script&lang=js"

import "./ArchivoPlaDatos.vue?vue&type=style&index=0&id=1a0dc598&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0dc598"]])

export default __exports__